import { useSelector } from "react-redux";
import styles from './DropdownFilter.module.css';

export default function DropdownFilter({ handleSelect, seriesIds, label, value, column }) {

  // get data from Redux state
  const data = useSelector((state) => {
    const ids = Array.isArray(seriesIds) ? seriesIds : [seriesIds];
    return ids.flatMap((id) => state.visualizer.productDataBySeries[id] || []);
  }) || [];
  
  // ensure unique dropdown options
  const uniqueOptions = [
  ...new Set(Object.values(data[0]).map(d => d[column]))
];



  const dropdownOptions = uniqueOptions.map((option, index) => (
    <option key={index} value={option} defaultValue={value === option}>
      {option}
    </option>
  ));

  return (
    <select
      name={column}
      className={styles.dropdown}
      value={value}
      onChange={handleSelect}
    >
      <option value="-1">All {label}</option>
      {dropdownOptions}
    </select>
  );
}
